export const AUTH_ROUTE_QUERY_PARAMS = {
  ORGANIZATION_ID: 'orgId',
  ORGANIZATION_NAME: 'orgName',
  MISSION_ID: 'missionId',
  ALREADY_REGISTERED: 'alreadyRegistered',
  INVITING_USER_NAME: 'fullName',
  RETURN_URL: 'returnUrl',
  MESSAGE: 'message',
};
